import React, { useEffect, useRef } from "react";
import "./FactBox.scss";
import img from "../../assets/fact.png";
import { gsap } from "gsap";

function FactBox() {
  const copyBox = useRef();
  useEffect(() => {
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: copyBox.current,
        start: "top 75%",
        end: "top 75%",
        once: true,
      },
    });
    tl.to("#house", { opacity: 1, duration: 0.5 }).to(
      "#house",
      { x: 73, duration: 1.5 },
      "-=0.5"
    );
  }, []);
  return (
    <section className="factBox">
      <img src={img} alt="" className="factBox-img" />
      <div className="factBox-copy" ref={copyBox}>
        <svg
          id="Layer_1"
          data-name="Layer 1"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 100.53 45"
          className="factBox-icon"
        >
          <path
            id="truck"
            className="cls-1F"
            d="M61.63,29.32l-6.1-.81L52,22.42a5.23,5.23,0,0,0-4.62-2.68h-6.7a1.2,1.2,0,0,0-1.21,1.2V32a2.26,2.26,0,0,1-2.28,2.28H5.4a.77.77,0,0,0-.8.8v4a1.12,1.12,0,0,0,1.14,1.13H8.42a5.24,5.24,0,0,0,10.45,0H49.09a5.25,5.25,0,0,0,10.46,0h1.74a2.38,2.38,0,0,0,2.35-2.34V31.66A2.32,2.32,0,0,0,61.63,29.32Zm-47.92,13a2.62,2.62,0,0,1-2.61-2.61,2.61,2.61,0,1,1,5.22,0A2.61,2.61,0,0,1,13.71,42.32ZM43.33,28.38V23h4a2,2,0,0,1,1.74,1l2.48,4.36ZM54.39,42.32a2.61,2.61,0,0,1-2.61-2.61,2.61,2.61,0,1,1,5.22,0A2.53,2.53,0,0,1,54.39,42.32Z"
            transform="translate(36.9 0)"
          />
          <path
            id="house"
            className="cls-1F"
            d="M-32.3,30.46a1.18,1.18,0,0,0,1.14,1.14h30A1.18,1.18,0,0,0,0,30.46V16.25H3.08A1.55,1.55,0,0,0,4,13.44L-15.21.3a1.62,1.62,0,0,0-1.88,0L-36.25,13.44a1.55,1.55,0,0,0,.87,2.81h3.08V30.46Zm6.9-12.67a.6.6,0,0,1,.6-.6h10.12v-3a.76.76,0,0,1,1.21-.6l6.3,4.56a.75.75,0,0,1,0,1.2l-6.3,4.56a.76.76,0,0,1-1.21-.6v-3H-24.8a.6.6,0,0,1-.6-.6V17.79Z"
            transform="translate(36.9 0)"
          />
        </svg>
        <p className="factBox-copy--title">
          FOLLOW THE CROWDS:
          <br />
          Expensive housing markets could make the best investments
        </p>
        <p className="factBox-copy--body">
          It seems counterintuitive, but housing markets where prices have risen
          rapidly in recent years may see even greater gains in the future.
        </p>
        <p className="factBox-copy--body">
          “Price appreciation tends to be strongest in places that are
          experiencing growth in jobs and population, especially when those
          areas have limited housing supply,” explains Yun. “In cities and
          regions where factories are closing down and people are moving away,
          home prices can be very affordable, but those values may very well
          stagnate or only grow at a minimal rate due to excess housing supply.”
        </p>
      </div>
    </section>
  );
}

export default FactBox;
